<template>
  <div class="despre-noi-container1">
    <app-navigation
      imageSrc="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
      rootClassName="navigationroot-class-name6"
    ></app-navigation>
    <main class="despre-noi-main">
      <div class="despre-noi-hero section-container">
        <div class="despre-noi-max-width1 max-content-container">
          <div class="despre-noi-content-container1">
            <h1 class="despre-noi-text100">
              <span>
                COMBINATUL AUTO
                <span v-html="raw2kz5"></span>
              </span>
              <span class="despre-noi-text102">nr.4</span>
              <br />
              <span class="despre-noi-text104">s</span>
              <span class="despre-noi-text105">
                ervicii de
                <span v-html="rawr4yy"></span>
              </span>
              <br />
              <span class="despre-noi-text107">calitate</span>
              <br />
              <span class="despre-noi-text108">
                IN
                <span v-html="rawzpq1"></span>
              </span>
              <span class="despre-noi-text109">Moldova</span>
            </h1>
            <span class="despre-noi-text110">
              <span>N</span>
              <span class="despre-noi-text112">
                oi garantam executarea rapida si la un nivel
                <span v-html="raw5e7o"></span>
              </span>
              <br />
              <span class="despre-noi-text114">
                inalt a comenzilor Dvs.
                <span v-html="rawl1n3"></span>
              </span>
            </span>
            <div class="despre-noi-btns-container1">
              <a
                href="#servicii"
                class="despre-noi-primary button-primary button-lg button"
              >
                servicii
              </a>
              <a
                href="#contacts"
                class="despre-noi-secondary button button-outline button-lg-border"
              >
                adresa noastra
              </a>
            </div>
          </div>
          <div class="despre-noi-video-container">
            <div class="despre-noi-container2"></div>
          </div>
        </div>
        <div class="despre-noi-blue-background"></div>
      </div>
      <div class="despre-noi-text-content">
        <h1 class="despre-noi-text115">Despre noi</h1>
        <span class="despre-noi-text116">
          <span class="despre-noi-text117">
            Istoria
            <span v-html="raw3u6g"></span>
          </span>
          <span>
            SA „Combinatul Auto Nr.4 din Chișinău”
            <span v-html="rawrcz6"></span>
          </span>
          <span class="despre-noi-text119">
            începe din anul 1945 sub denumirea
            <span v-html="rawfc5a"></span>
          </span>
          <span>„СПЕЦТОРГ”,</span>
          <span class="despre-noi-text121"><span v-html="rawauqx"></span></span>
          <br />
          <span class="despre-noi-text123">
            iar de-a lungul anilor isi schimbă de mai multe ori denumirea.
            <span v-html="rawfjee"></span>
          </span>
          <br />
          <span class="despre-noi-text125">
            In
            <span v-html="raw2fvp"></span>
          </span>
          <span class="despre-noi-text126">
            iulie 1976 a fost format „Combinatul Auto Nr.4” ca unitate juridica.
            <span v-html="rawnp85"></span>
          </span>
          <br />
          <span class="despre-noi-text127"></span>
          <br />
          <span class="despre-noi-text128">
            Personalul
            <span v-html="rawx6qx"></span>
          </span>
          <span class="despre-noi-text129">
            intreprinderii reprezinta o echipa profesionista, cu experienta vasta
            in domeniu,
            <span v-html="rawe2by"></span>
          </span>
          <br />
          <span class="despre-noi-text131">
            iar clientii care cauta un partener de încredere vor fi multumiti de
            colaborarea cu intreprinderea noastra.
          </span>
          <br />
          <span class="despre-noi-text132">
            Noi garantam executarea rapida si la un nivel înalt a comenzilor Dvs.
            <span v-html="rawputf"></span>
          </span>
          <br />
          <span class="despre-noi-text133"></span>
          <br />
          <span class="despre-noi-text134">
            La
            <span v-html="rawoh1u"></span>
          </span>
          <span class="despre-noi-text135">
            serviciile întreprinderii noastre apeleaza atit intreprinderi de stat
            cit si intreprinderi comerciale, clientela este foarte diversa.
          </span>
          <br />
          <span class="despre-noi-text136"></span>
          <br />
          <span class="despre-noi-text137">Intreg</span>
          <span class="despre-noi-text138">
            teritoriul intreprinderii este monitorizat de un sistem de camere de
            monitorizare, precum si de paza fizica.
          </span>
          <br />
          <span class="despre-noi-text139"></span>
          <br />
          <span class="despre-noi-text140">
            Combinatul
            <span v-html="rawlout"></span>
          </span>
          <span class="despre-noi-text141">
            Auto Nr.4
            <span v-html="raw7b7r"></span>
          </span>
          <span class="despre-noi-text142">Chisinau</span>
          <span class="despre-noi-text143">
            are un teritoriu mare pentru parcarea camioanelor de mare tonaj si a
            autocarelor.
          </span>
          <br />
          <span class="despre-noi-text144">
            Pe
            <span v-html="raw2850"></span>
          </span>
          <span class="despre-noi-text145">
            linga parcare, companiile de transport pot beneficia de un complex de
            servicii suplimentare.
            <span v-html="rawz876"></span>
          </span>
          <br />
          <span></span>
          <span class="despre-noi-text148">
            Pe
            <span v-html="rawiwz1"></span>
          </span>
          <span class="despre-noi-text149">
            teritoriul intreprinderii este spalatorie pentru camioane, ateliere de
            reparatie a motoarelor,
            <span v-html="raw4cc1"></span>
          </span>
          <br />
          <span class="despre-noi-text151">
            a sistemului de suspensie, a sistemelor electrice, servicii de sudare,
            atelier de vopsire.
            <span v-html="rawovdy"></span>
          </span>
          <br />
          <span class="despre-noi-text152">Angajatii</span>
          <span class="despre-noi-text153">
            pot lua masa la cantina intreprinderii unde gasesc mereu prinzuri
            calde.
            <span v-html="rawfqrp"></span>
          </span>
          <br />
          <span></span>
        </span>
      </div>
      <div class="despre-noi-speakers section-container">
        <div id="servicii" class="despre-noi-max-width2 max-content-container">
          <div class="despre-noi-heading-container1">
            <span class="despre-noi-text155">servicii de calitate</span>
            <h1 class="despre-noi-text156 Heading2">
              <span>serviciile noastre</span>
            </h1>
          </div>
          <div class="despre-noi-speakers-container">
            <router-link to="/transport">
              <speaker-card
                role="livrare National"
                lastName="marfuri"
                firstName="Transport"
                imageSrc="/15-300h.webp"
                rootClassName="speaker-cardroot-class-name9"
                class="despre-noi-component11"
              ></speaker-card>
            </router-link>
            <router-link to="/reparatii-auto">
              <speaker-card
                role="servicii electrice si mecanice"
                lastName="auto"
                firstName="reparatii"
                imageSrc="/16-300h-300h.webp"
                class="despre-noi-component12"
              ></speaker-card>
            </router-link>
            <speaker-card
              role="rapid si calitativ"
              lastName="auto"
              firstName="spalatorie"
              imageSrc="/14-300h.webp"
            ></speaker-card>
            <router-link to="/parcare-auto">
              <speaker-card
                role="siguranta maxima"
                lastName="auto"
                firstName="parcare"
                imageSrc="/13-300h.webp"
                class="despre-noi-component14"
              ></speaker-card>
            </router-link>
            <router-link to="/arenda-spatii">
              <speaker-card
                role="siguranta maxima"
                lastName="spatiilor"
                firstName="arenda"
                imageSrc="/12-300h.webp"
                class="despre-noi-component15"
              ></speaker-card>
            </router-link>
            <router-link to="/alimentarea-publica">
              <speaker-card
                role="servicii de alimentatie (cantina)"
                lastName="publica"
                firstName="alimentatie"
                imageSrc="/cantina-300w.webp"
                class="despre-noi-component16"
              ></speaker-card>
            </router-link>
            <speaker-card
              role="in curind"
              lastName="noi"
              firstName="servicii "
              imageSrc="/rm-300h.webp"
              rootClassName="speaker-cardroot-class-name10"
            ></speaker-card>
            <speaker-card
              role="in curind ..."
              lastName="noi"
              firstName="servicii"
              imageSrc="/rm-300h.webp"
              rootClassName="speaker-cardroot-class-name11"
            ></speaker-card>
          </div>
        </div>
      </div>
      <div class="despre-noi-numbers-banner section-container">
        <div class="despre-noi-container3 max-content-container">
          <div class="despre-noi-heading-container2">
            <span class="despre-noi-text158">
              Personalul intreprinderii reprezinta o echipa profesionista, cu
              experienta vasta in domeniu
              <span v-html="rawnhf4"></span>
            </span>
            <h1 class="despre-noi-text159 Heading2">
              <span>
                servicii la preturi accesibile
                <span v-html="rawsr8x"></span>
              </span>
            </h1>
          </div>
          <div class="despre-noi-numbers-container">
            <numbers-card text="expeditiii"></numbers-card>
            <numbers-card
              text="ani"
              number="12"
              imageSrc="/interface%20time%20reset-200h.webp"
            ></numbers-card>
            <numbers-card
              text="evenimente"
              number="64"
              imageSrc="/interface%20calendar%20favorite-200h.webp"
            ></numbers-card>
            <numbers-card
              text="companii"
              number="234"
              imageSrc="/shopping%20bag%20suit%20case-200h.webp"
            ></numbers-card>
            <numbers-card
              text="orase"
              number="14"
              imageSrc="/travel%20map%20location%20pin-200h.webp"
            ></numbers-card>
            <numbers-card
              text="diagnosticari"
              number="1,071"
              imageSrc="/interface%20time%20reset-200h.webp"
            ></numbers-card>
          </div>
        </div>
      </div>
      <div class="despre-noi-location">
        <img
          id="news"
          alt="image"
          srcset="/cars-1500w.webp 1200w, /cars-tablet.webp 800w, /cars-mobile.webp 480w"
          sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
          src="/cars-1500w.webp"
          class="despre-noi-image"
        />
        <div class="despre-noi-content-container2 section-container">
          <div class="despre-noi-container4">
            <span class="despre-noi-text161">REPARAtIE AUTO</span>
            <span class="despre-noi-text162">Calitativ</span>
            <div class="despre-noi-container5">
              <span class="despre-noi-text163"><span>motoare</span></span>
              <span class="despre-noi-text165"><span>caroserii</span></span>
              <span class="despre-noi-text167"><span>diagnosticare</span></span>
            </div>
            <div class="despre-noi-container6">
              <span class="despre-noi-text169">
                oferim servicii de reparație auto
              </span>
              <span class="despre-noi-text170">
                <span>
                  la toate tipurile de mașini, secția reparații este dotată cu
                  mecanisme care ne permit a efectua reparații auto calitative și
                  anume: motoare, caroserii, sisteme de transmisie, sisteme de
                  control, sisteme hidraulice, acumulatoare, radiatoare, sisteme
                  de încălzire, sisteme de răcire, sisteme de frînare.
                  <span v-html="rawaqyf"></span>
                </span>
                <br />
                <span>
                  Identificăm cele mai complexe defecțiuni prin diagnosticarea
                  computerizată.
                  <span v-html="rawdg7w"></span>
                </span>
              </span>
              <div class="despre-noi-btns-container2">
                <a
                  href="#contacts"
                  class="despre-noi-register button-secondary button button-md"
                >
                  programeaza-te
                </a>
                <a
                  href="#contacts"
                  class="despre-noi-learn-more button button-outline button-md-border"
                >
                  adresa
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="despre-noi-agenda section-container">
        <div id="contacts" class="despre-noi-max-width3 max-content-container">
          <div class="despre-noi-heading-container3">
            <h1 id="contact" class="despre-noi-text174 Heading2">
              <span>ADRESA NOASTRA</span>
            </h1>
            <span class="despre-noi-text176">
              te asteptam sa testezi serviciile noastre
            </span>
          </div>
        </div>
      </div>
      <div class="despre-noi-workshops">
        <div class="despre-noi-content-container3">
          <div class="despre-noi-container7">
            <h1 class="despre-noi-text177 Heading2">
              <span>contacte</span>
              <br />
              <span class="despre-noi-text180">
                MD-2002
                <span v-html="rawlc8e"></span>
              </span>
              <span><span v-html="raweuhp"></span></span>
              <span>MUN.CHIsINaU, STR.PaDURII 13</span>
            </h1>
            <span class="despre-noi-text183">
              ----------------------------------------------
            </span>
            <span class="despre-noi-text184">
              <span></span>
              <br />
              <span>MobILE:</span>
              <span class="despre-noi-text187">
                <span v-html="rawetdh"></span>
              </span>
              <span class="despre-noi-text188">
                (+373)
                <span v-html="raw3jl4"></span>
              </span>
              <a href="tel:37369322886">
                <span class="despre-noi-text189">69322886</span>
              </a>
              <span class="despre-noi-text190"></span>
              <br />
              <span>
                Tel/Fax: (+373)
                <span v-html="rawsfj1"></span>
              </span>
              <a href="tel:37322521144">
                <span class="despre-noi-text192">22521144</span>
              </a>
              <br />
              <span></span>
              <br />
              <span></span>
              <a href="mailto:COMBINATAUTO@GMAIL.COM?subject=email">
                <span class="despre-noi-text196">Combinatauto@gmail.com</span>
              </a>
              <span class="despre-noi-text197"></span>
              <span class="despre-noi-text198"></span>
              <span class="despre-noi-text199"></span>
              <span><span v-html="raw4lq6"></span></span>
              <br />
              <span></span>
              <a href="mailto:DSACA4@MAIL.RU?subject=">
                <span class="despre-noi-text202">dsaca4@mail.ru</span>
                <br class="despre-noi-br27" />
              </a>
            </span>
          </div>
        </div>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1361.1581244223369!2d28.896054673961334!3d46.97512272089735!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40c9796e1caa0069%3A0x18af5b1f21321713!2sSA%20Combinatul%20Auto%20nr.4%2C%20Chi%C8%99in%C4%83u!5e0!3m2!1sro!2s!4v1650529500065!5m2!1sro!2s"
          title="maps"
          class="despre-noi-iframe"
        ></iframe>
      </div>
      <div class="despre-noi-previous-events section-container">
        <div class="despre-noi-max-width4 max-content-container">
          <div class="despre-noi-heading-container4">
            <h1 class="despre-noi-text203 Heading2">
              <span>PARTENERUL TAU DE INCREDERE</span>
            </h1>
            <span class="despre-noi-text205">
              garantam executarea rapida si calitativa a comenzilor Dumneavoastra
            </span>
          </div>
        </div>
      </div>
    </main>
    <app-footer rootClassName="footerroot-class-name6"></app-footer>
  </div>
</template>

<script>
import AppNavigation from '../components/navigation'
import SpeakerCard from '../components/speaker-card'
import NumbersCard from '../components/numbers-card'
import AppFooter from '../components/footer'

export default {
  name: 'DespreNoi',
  props: {},
  components: {
    AppNavigation,
    SpeakerCard,
    NumbersCard,
    AppFooter,
  },
  data() {
    return {
      raw2kz5: ' ',
      rawr4yy: ' ',
      rawzpq1: ' ',
      raw5e7o: ' ',
      rawl1n3: ' ',
      raw3u6g: ' ',
      rawrcz6: ' ',
      rawfc5a: ' ',
      rawauqx: ' ',
      rawfjee: ' ',
      raw2fvp: ' ',
      rawnp85: ' ',
      rawx6qx: ' ',
      rawe2by: ' ',
      rawputf: ' ',
      rawoh1u: ' ',
      rawlout: ' ',
      raw7b7r: ' ',
      raw2850: ' ',
      rawz876: ' ',
      rawiwz1: ' ',
      raw4cc1: ' ',
      rawovdy: ' ',
      rawfqrp: ' ',
      rawnhf4: ' ',
      rawsr8x: ' ',
      rawaqyf: ' ',
      rawdg7w: ' ',
      rawlc8e: ' ',
      raweuhp: ' ',
      rawetdh: ' ',
      raw3jl4: ' ',
      rawsfj1: ' ',
      raw4lq6: ' ',
    }
  },
  metaInfo: {
    title: 'Despre-Noi - SA Combinatul Auto Nr.4 din Chișinău',
    meta: [
      {
        name: 'description',
        content:
          'SA Combinatul Auto Nr.4 din Chișinău, oferă o gamă largă de servicii electrice și mecanice la prețuri accesibile pentru fiecare.',
      },
      {
        property: 'og:title',
        content: 'Despre-Noi - SA Combinatul Auto Nr.4 din Chișinău',
      },
      {
        property: 'og:description',
        content:
          'SA Combinatul Auto Nr.4 din Chișinău, oferă o gamă largă de servicii electrice și mecanice la prețuri accesibile pentru fiecare.',
      },
      {
        property: 'og:image',
        content:
          'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/7df3687e-9d61-4851-bd9b-b6ae978e2570/ea494eb0-6cf8-464c-b070-cddce041bc5c?org_if_sml=1&q=80&force_format=original',
      },
    ],
  },
}
</script>

<style scoped>
.despre-noi-container1 {
  width: 100%;
  display: flex;
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
  align-items: center;
  flex-direction: column;
}
 
.despre-noi-main {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
 
.despre-noi-hero {
  position: relative;
  padding-top: 128px;
}
 
.despre-noi-max-width1 {
  z-index: 1;
  align-items: stretch;
}
 
.despre-noi-content-container1 {
  flex: 1;
  display: flex;
  max-width: 45%;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
}
 
.despre-noi-text100 {
  font-size: 60px;
  font-style: normal;
  font-family: IBM Plex Sans Condensed;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: var(--dl-space-space-unit);
  text-transform: uppercase;
  text-decoration: none;
}
 
.despre-noi-text102 {
  text-transform: lowercase;
}
 
.despre-noi-text104 {
  color: var(--dl-color-scheme-pink);
}
 
.despre-noi-text105 {
  color: var(--dl-color-scheme-pink);
  text-transform: lowercase;
}
 
.despre-noi-text107 {
  color: var(--dl-color-scheme-pink);
  text-transform: lowercase;
}
 
.despre-noi-text108 {
  font-style: normal;
  font-weight: 600;
  text-transform: lowercase;
}
 
.despre-noi-text109 {
  font-style: normal;
  font-weight: 600;
  text-transform: capitalize;
}
 
.despre-noi-text110 {
  font-style: normal;
  font-weight: 500;
  margin-bottom: 42px;
}
 
.despre-noi-text112 {
  text-transform: lowercase;
}
 
.despre-noi-text114 {
  text-transform: lowercase;
}
 
.despre-noi-btns-container1 {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
}
 
.despre-noi-primary {
  margin-right: var(--dl-space-space-oneandhalfunits);
  text-decoration: none;
}
 
.despre-noi-secondary {
  text-decoration: none;
}
 
.despre-noi-video-container {
  flex: 1;
  width: 200px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
 
.despre-noi-container2 {
  width: 100%;
  height: 511px;
  display: flex;
  transition: 0.3s;
  background-size: cover;
  background-image: url("/home-600h.webp");
  background-position: center;
}
 
.despre-noi-container2:hover {
  transform: scale(1.02);
  box-shadow: 5px 5px 10px 0px rgba(111, 102, 102, 0.31);
}
 
.despre-noi-blue-background {
  top: 0px;
  right: 0px;
  width: 47%;
  height: 100px;
  position: absolute;
  min-height: 80%;
  background-size: cover;
  background-image: url("/blue-bg-1500w.webp");
  background-repeat: no-repeat;
}
 
.despre-noi-text-content {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: var(--dl-space-space-threeunits);
  padding-left: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: column;
  padding-bottom: var(--dl-space-space-oneandhalfunits);
  justify-content: space-between;
}
 
.despre-noi-text115 {
  font-size: 3rem;
  text-align: center;
}
 
.despre-noi-text116 {
  max-width: var(--dl-size-size-maxwidth);
  margin-top: var(--dl-space-space-twounits);
  text-align: center;
  margin-bottom: var(--dl-space-space-twounits);
}
 
.despre-noi-text117 {
  text-transform: capitalize;
}
 
.despre-noi-text119 {
  text-transform: lowercase;
}
 
.despre-noi-text121 {
  text-transform: lowercase;
}
 
.despre-noi-text123 {
  text-transform: lowercase;
}
 
.despre-noi-text125 {
  text-transform: capitalize;
}
 
.despre-noi-text126 {
  text-transform: lowercase;
}
 
.despre-noi-text127 {
  text-transform: lowercase;
}
 
.despre-noi-text128 {
  text-transform: capitalize;
}
 
.despre-noi-text129 {
  text-transform: lowercase;
}
 
.despre-noi-text131 {
  text-transform: lowercase;
}
 
.despre-noi-text132 {
  text-transform: lowercase;
}
 
.despre-noi-text133 {
  text-transform: lowercase;
}
 
.despre-noi-text134 {
  text-transform: capitalize;
}
 
.despre-noi-text135 {
  text-transform: lowercase;
}
 
.despre-noi-text136 {
  text-transform: lowercase;
}
 
.despre-noi-text137 {
  text-transform: capitalize;
}
 
.despre-noi-text138 {
  text-transform: lowercase;
}
 
.despre-noi-text139 {
  text-transform: lowercase;
}
 
.despre-noi-text140 {
  text-transform: capitalize;
}
 
.despre-noi-text141 {
  text-transform: lowercase;
}
 
.despre-noi-text142 {
  text-transform: capitalize;
}
 
.despre-noi-text143 {
  text-transform: lowercase;
}
 
.despre-noi-text144 {
  text-transform: capitalize;
}
 
.despre-noi-text145 {
  text-transform: lowercase;
}
 
.despre-noi-text148 {
  text-transform: capitalize;
}
 
.despre-noi-text149 {
  text-transform: lowercase;
}
 
.despre-noi-text151 {
  text-transform: lowercase;
}
 
.despre-noi-text152 {
  text-transform: capitalize;
}
 
.despre-noi-text153 {
  text-transform: lowercase;
}
 
.despre-noi-speakers {
  display: flex;
  padding-top: var(--dl-space-space-threeunits);
  flex-direction: column;
}
 
.despre-noi-max-width2 {
  flex-direction: column;
}
 
.despre-noi-heading-container1 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
 
.despre-noi-text155 {
  color: var(--dl-color-scheme-darkgray);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
.despre-noi-text156 {
  text-align: center;
}
 
.despre-noi-speakers-container {
  width: 100%;
  display: grid;
  grid-row-gap: var(--dl-space-space-fourunits);
  grid-column-gap: 30px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
 
.despre-noi-component11 {
  text-decoration: none;
}
 
.despre-noi-component12 {
  text-decoration: none;
}
 
.despre-noi-component14 {
  text-decoration: none;
}
 
.despre-noi-component15 {
  text-decoration: none;
}
 
.despre-noi-component16 {
  text-decoration: none;
}
 
.despre-noi-numbers-banner {
  display: flex;
  padding-top: var(--dl-space-space-fiveunits);
  flex-direction: column;
  background-size: cover;
  background-image: url("/29bg-1500w.webp");
}
 
.despre-noi-container3 {
  flex-direction: column;
}
 
.despre-noi-heading-container2 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
 
.despre-noi-text158 {
  color: var(--dl-color-scheme-white);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
.despre-noi-text159 {
  color: var(--dl-color-scheme-white);
  text-align: center;
}
 
.despre-noi-numbers-container {
  width: 100%;
  display: grid;
  grid-row-gap: var(--dl-space-space-fourunits);
  grid-column-gap: 30px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
}
 
.despre-noi-location {
  width: 100%;
  display: flex;
  align-items: stretch;
  flex-direction: row;
}
 
.despre-noi-image {
  width: 55%;
  max-height: 950px;
  object-fit: cover;
}
 
.despre-noi-content-container2 {
  flex: 1;
  display: flex;
  align-items: stretch;
  padding-top: 100px;
  padding-right: var(--dl-space-space-threeunits);
  flex-direction: row;
  background-color: var(--dl-color-scheme-black);
}
 
.despre-noi-container4 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
 
.despre-noi-text161 {
  color: var(--dl-color-scheme-white);
  font-size: 56px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.1;
  margin-left: -100px;
  padding-top: 4px;
  padding-left: 18px;
  margin-bottom: 6px;
  padding-right: 11px;
  padding-bottom: 6px;
  background-color: var(--dl-color-scheme-lightblue);
}
 
.despre-noi-text162 {
  color: var(--dl-color-scheme-white);
  font-size: 56px;
  font-style: normal;
  font-weight: 300;
  line-height: 1.1;
}
 
.despre-noi-container5 {
  display: flex;
  align-items: flex-end;
  margin-bottom: var(--dl-space-space-twounits);
  flex-direction: column;
}
 
.despre-noi-text163 {
  color: var(--dl-color-scheme-pink);
  font-size: 56px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.1;
  margin-left: var(--dl-space-space-fiveunits);
}
 
.despre-noi-text165 {
  color: var(--dl-color-scheme-pink);
  font-size: 56px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.1;
  margin-left: -36px;
}
 
.despre-noi-text167 {
  color: var(--dl-color-scheme-pink);
  font-size: 56px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.1;
  margin-left: var(--dl-space-space-fiveunits);
}
 
.despre-noi-container6 {
  flex: 1;
  width: 100%;
  display: flex;
  max-width: 350px;
  align-items: flex-start;
  margin-left: 124px;
  flex-direction: column;
}
 
.despre-noi-text169 {
  color: var(--dl-color-scheme-white);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  margin-bottom: var(--dl-space-space-halfunit);
}
 
.despre-noi-text170 {
  color: var(--dl-color-scheme-white);
  text-align: justify;
  margin-bottom: var(--dl-space-space-twounits);
  text-transform: none;
}
 
.despre-noi-btns-container2 {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
}
 
.despre-noi-register {
  text-decoration: none;
}
 
.despre-noi-learn-more {
  color: var(--dl-color-scheme-white);
  transition: 0.3s;
  border-color: var(--dl-color-scheme-white);
  text-decoration: none;
}
 
.despre-noi-learn-more:hover {
  border-color: var(--dl-color-scheme-pink);
}
 
.despre-noi-agenda {
  display: flex;
  padding-top: var(--dl-space-space-fourunits);
  flex-direction: column;
  padding-bottom: 0px;
}
 
.despre-noi-max-width3 {
  flex-direction: column;
}
 
.despre-noi-heading-container3 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
 
.despre-noi-text174 {
  text-align: center;
}
 
.despre-noi-text176 {
  color: var(--dl-color-scheme-darkgray);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
.despre-noi-workshops {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: row;
}
 
.despre-noi-content-container3 {
  flex: 1;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: center;
  background-color: rgba(144, 149, 167, 0.08);
}
 
.despre-noi-container7 {
  flex: 0 0 auto;
  display: flex;
  max-width: 366px;
  align-items: flex-start;
  margin-right: 107px;
  flex-direction: column;
}
 
.despre-noi-text177 {
  margin-bottom: 42px;
}
 
.despre-noi-text180 {
  color: var(--dl-color-scheme-pink);
}
 
.despre-noi-text183 {
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  margin-bottom: var(--dl-space-space-halfunit);
}
 
.despre-noi-text184 {
  font-size: 20px;
  font-style: normal;
  text-align: justify;
  font-family: IBM Plex Sans Condensed;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: var(--dl-space-space-threeunits);
  letter-spacing: 0.02em;
  text-transform: uppercase;
  text-decoration: none;
}
 
.despre-noi-text187 {
  font-weight: 700;
}
 
.despre-noi-text188 {
  font-weight: 700;
}
 
.despre-noi-text189 {
  font-weight: 700;
  text-decoration: underline;
}
 
.despre-noi-text190 {
  font-weight: 700;
  text-decoration: underline;
}
 
.despre-noi-text192 {
  text-decoration: underline;
}
 
.despre-noi-text196 {
  text-decoration: underline;
}
 
.despre-noi-text197 {
  text-decoration: underline;
}
 
.despre-noi-text198 {
  text-decoration: underline;
}
 
.despre-noi-text199 {
  text-decoration: underline;
}
 
.despre-noi-text202 {
  text-decoration: underline;
}
 
.despre-noi-br27 {
  text-decoration: underline;
}
 
.despre-noi-iframe {
  width: 50%;
  min-height: 880px;
}
 
.despre-noi-previous-events {
  display: flex;
  position: relative;
  flex-direction: column;
  padding-bottom: 150px;
}
 
.despre-noi-max-width4 {
  flex-direction: column;
}
 
.despre-noi-heading-container4 {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-fourunits);
  flex-direction: column;
}
 
.despre-noi-text203 {
  text-align: center;
}
 
.despre-noi-text205 {
  color: var(--dl-color-scheme-darkgray);
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
 
@media(max-width: 991px) {
  .despre-noi-max-width1 {
    flex-direction: column;
  }
  .despre-noi-content-container1 {
    max-width: 100%;
    margin-bottom: 42px;
  }
  .despre-noi-container2 {
    width: 583px;
  }
  .despre-noi-blue-background {
    top: auto;
    width: 100%;
    bottom: 0px;
    min-height: 40%;
  }
  .despre-noi-text116 {
    max-width: 100%;
  }
  .despre-noi-speakers-container {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .despre-noi-numbers-container {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .despre-noi-location {
    flex-direction: column;
  }
  .despre-noi-image {
    width: 100%;
  }
  .despre-noi-content-container2 {
    padding-top: 0px;
    padding-left: var(--dl-space-space-threeunits);
  }
  .despre-noi-container4 {
    margin-top: -100px;
    align-items: center;
  }
  .despre-noi-container6 {
    max-width: 100%;
    margin-left: 0px;
  }
  .despre-noi-container7 {
    margin-right: var(--dl-space-space-unit);
  }
  .despre-noi-iframe {
    width: 50%;
    min-height: 600px;
  }
}
 
@media(max-width: 767px) {
  .despre-noi-container2 {
    width: 505px;
  }
  .despre-noi-text-content {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .despre-noi-text116 {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .despre-noi-speakers-container {
    grid-template-columns: 1fr 1fr;
  }
  .despre-noi-numbers-container {
    grid-template-columns: 1fr 1fr;
  }
  .despre-noi-image {
    max-height: 100%;
  }
  .despre-noi-content-container2 {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .despre-noi-text161 {
    margin-left: -24px;
  }
  .despre-noi-btns-container2 {
    width: 100%;
    align-items: stretch;
    flex-direction: column;
  }
  .despre-noi-workshops {
    flex-direction: column-reverse;
    padding-bottom: var(--dl-space-space-twounits);
  }
  .despre-noi-container7 {
    max-width: 100%;
    padding-top: var(--dl-space-space-twounits);
    margin-right: 0px;
    padding-left: var(--dl-space-space-oneandhalfunits);
    padding-right: var(--dl-space-space-oneandhalfunits);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .despre-noi-iframe {
    width: 100%;
  }
  .despre-noi-previous-events {
    padding-bottom: var(--dl-space-space-sixunits);
  }
}
 
@media(max-width: 479px) {
  .despre-noi-text100 {
    font-size: 60px;
  }
  .despre-noi-container2 {
    width: 424px;
  }
  .despre-noi-text-content {
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .despre-noi-speakers-container {
    grid-template-columns: 1fr;
  }
  .despre-noi-text163 {
    font-size: 50px;
    margin-right: var(--dl-space-space-oneandhalfunits);
  }
  .despre-noi-text165 {
    font-size: 50px;
    margin-right: var(--dl-space-space-oneandhalfunits);
  }
  .despre-noi-text167 {
    font-size: 50px;
    margin-left: var(--dl-space-space-oneandhalfunits);
    margin-right: var(--dl-space-space-oneandhalfunits);
  }
  .despre-noi-text170 {
    text-align: justify;
  }
}
</style>
